import { useQueryClient } from '@tanstack/react-query';
import type { Connection } from '@/api/types';
import { qk } from '@/api/queries';
import { Avatar } from '@/components/ui/Avatar';
import type { DirectPerson } from './composer';

/** Fill a direct invite's person from the Friends cache when the caller only had an id (K1). */
export function useDirectPerson(to: DirectPerson | undefined): DirectPerson | null {
  const qc = useQueryClient();
  if (!to) return null;
  if (to.display_name && to.avatar) return to;
  const c = qc.getQueryData<{ connections: Connection[] }>(qk.connections)?.connections.find((x) => x.user.id === to.id);
  return { ...to, display_name: to.display_name ?? c?.user.display_name, avatar: to.avatar ?? c?.user.avatar };
}

/** "To: Maya" on the create sheet of a direct invite. */
export function DirectTo({ person }: { person: DirectPerson }) {
  return (
    <div className="flex items-center gap-3 rounded-card bg-raised p-3" data-testid="invite-direct-to" data-user-id={person.id}>
      <Avatar avatar={person.avatar} size={44} label={person.display_name} />
      <div className="min-w-0 flex-1">
        <p className="text-[13px] text-muted">To</p>
        <p className="truncate text-[17px] font-semibold leading-tight">{person.display_name ?? 'Your friend'}</p>
      </div>
    </div>
  );
}
